import useUI from 'hooks/use-ui';
import { useIsConciergeEnabled } from 'src/concierge/use-is-concierge-enabled';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

// Whether the PDP Concierge panel may show on this surface. The caller adds the
// Add to cart condition, so the panel only appears where the product is buyable.
export function useIsProductConciergePanelEnabled(): boolean {
  const { dispensary } = useDispensary();
  const UI = useUI();
  const conciergeEnabled = useIsConciergeEnabled(dispensary, UI);

  return conciergeEnabled && Boolean(dispensary?.id);
}
